module.exports = __webpack_public_path__ + "static/img/12.ab4a34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/12.png
// module id = k+f4
// module chunks = 0